import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Truck } from '../../../../widgets/control/truck-overview/truck.model';


@Component({
  selector: 'app-truck-gc-case-dialog',
  templateUrl: './truck-gc-case-dialog.component.html',
  styleUrls: ['./truck-gc-case-dialog.component.scss']
})
export class TruckGcCaseDialogComponent {

  truck: Truck;

  constructor(
    public dialogRef: MatDialogRef<TruckGcCaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.truck = data.truck;
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
